export const playback = {
  input: {
    media: {
      label: 'Pesan audio'
    },

    select_file: 'Pilih file | Pilih file lainnya'
  },

  state: {
    init: {
      description:
        'Pemutaran adalah elemen sirkuit yang memungkinkan klien untuk memutar ulang rekaman audio. Anda dapat mendengarkan dan mengunduh rekaman audio.'
    }
  }
};
